import Default from './photos/default.png';

// ---------------------------------------------------------------------------
import Lynette1 from './photos/2025-Lynette.JPG';
import RJ      from './photos/2025-RJ.JPG';
import Matt1    from './photos/2025-Matt.JPG';
import Jaden   from './photos/2025-Jaden.JPG';
import Alex    from './photos/2025-Alex.JPG';
import Andrew  from './photos/2025-Andrew.JPG';
import Brian1   from './photos/2025-Brian.JPG';
import Joyce1   from './photos/2025-Joyce.JPG';
import Kyle    from './photos/2025-Kyle.JPG';
import Nate    from './photos/2025-Nate.JPG';
import Pari1    from './photos/2025-Pari.JPG';
import Patrick from './photos/2025-Patrick.jpg';
import Ronald  from './photos/2025-Ronald.JPG';
import Vyan    from './photos/2025-Vyan.JPG';
import Xenia   from './photos/2025-Xenia.JPG';
// ---------------------------------------------------------------------------
import Matt from './photos/2026-Matt.jpg';

// ---------------------------------------------------------------------------
export const DEFAULT_PHOTO = Default;

export const WEBMASTER_2026_2027 = [
  { name: 'Matt Yee',      role: 'Webmaster',  photo: Matt,  instagram: 'https://www.instagram.com/yeematt/' },
];

export const TEAM_LEADS_2026_2027 = [
  // { name: 'Full Name', role: 'Frontend Lead', photo: SomePhoto, instagram: 'https://www.instagram.com/handle/' },
  // { name: 'Full Name', role: 'Backend Lead', photo: SomePhoto, instagram: 'https://www.instagram.com/handle/' },
  // { name: 'Full Name', role: 'UI/UX Lead', photo: SomePhoto, instagram: 'https://www.instagram.com/handle/' },
  // { name: 'Full Name', role: 'UI/UX Lead', photo: SomePhoto, instagram: 'https://www.instagram.com/handle/' },
];

export const INTERNS_2026_2027 = [
  // { name: 'Full Name', role: 'Web Intern', photo: SomePhoto, instagram: 'https://www.instagram.com/handle/' },
];

export const WEBMASTER_2025_2026 = [
  { name: 'Lynette Hemingway', role: 'Webmaster', photo: Lynette1, instagram: 'https://www.instagram.com/lynette_hemingway/' },
];

export const TEAM_LEADS_2025_2026 = [
  { name: 'RJ Tabelon',    role: 'Frontend Lead', photo: RJ,    instagram: 'https://www.instagram.com/limrinjo/' },
  { name: 'Matt Yee',      role: 'Backend Lead',  photo: Matt1,  instagram: 'https://www.instagram.com/yeematt/' },
  { name: 'Jaden Delapaz', role: 'UI/UX Lead',    photo: Jaden, instagram: 'https://www.instagram.com/jaden.delapaz/' },
];

export const INTERNS_2025_2026 = [
  { name: 'Alex Nguyen',    role: 'Web Intern', photo: Alex,    instagram: 'https://www.instagram.com/bluelockalex/' },
  { name: 'Andrew Ho',      role: 'Web Intern', photo: Andrew,  instagram: 'https://www.instagram.com/andrew_____ho/'},
  { name: 'Brian Paz',      role: 'Web Intern', photo: Brian1,   instagram: 'https://www.instagram.com/bluebrainedbeing/' },
  { name: 'Joyce Maniquis', role: 'Web Intern', photo: Joyce1,   instagram: 'https://www.instagram.com/joyce_m_92/' },
  { name: 'Kyle Yumul',     role: 'Web Intern', photo: Kyle,    instagram: 'https://www.instagram.com/km.yumul/' },
  { name: 'Nate Flores',    role: 'Web Intern', photo: Nate,    instagram: 'https://www.instagram.com/nate.flores24/' },
  { name: 'Pari Vyas',      role: 'Web Intern', photo: Pari1,    instagram: 'https://www.instagram.com/v.pa_ri/' },
  { name: 'Patrick Ouano',  role: 'Web Intern', photo: Patrick, instagram: 'https://www.instagram.com/patrick_ouano/' },
  { name: 'Ronald Nguyen',  role: 'Web Intern', photo: Ronald,  instagram: 'https://www.instagram.com/rngu.y/'},
  { name: 'Vyan Ramanthan', role: 'Web Intern', photo: Vyan },
  { name: 'Xenia Li',       role: 'Web Intern', photo: Xenia,   instagram: 'https://www.instagram.com/xeniali2024/' },
];